import React, { MutableRefObject } from "react";
import { Observer } from "mobx-react";

interface ListItemProps {
    listItemText: string;
    i: number;
    addListItem: Function;
    deleteListItem: Function;
    saveContent: Function;
}

const ListItem = React.forwardRef(
    (
        {
            i,
            deleteListItem,
            addListItem,
            saveContent,
            listItemText
        }: ListItemProps,
        ref: any
    ) => {
        let lastKey = "";
        const handleListItemKeyUp = (
            ev: React.KeyboardEvent<HTMLLIElement>,
            text: string
        ): void => {
            if (ev.key == "Enter") {
                ev.preventDefault;
                return addListItem();
            }

            if (ev.key == "Backspace") {
                // If the field was empty before then delete.
                if (lastKey == "" && ev.currentTarget.textContent == "") {
                    deleteListItem(i);
                }
                lastKey = ev.currentTarget.textContent || "";
            }
        };

        return (
            <Observer>
                {() => (
                    <li
                        className="list-group-item"
                        onKeyUp={ev => {
                            handleListItemKeyUp(ev, listItemText);
                        }}
                        suppressContentEditableWarning={true}
                        contentEditable={true}
                        onBlur={ev => saveContent(i, ev)}
                        ref={ref}
                    >
                        {listItemText}
                    </li>
                )}
            </Observer>
        );
    }
);

export default ListItem;
